import { IModifiersContext, IFilterValues } from './modifiersContext';

export enum ModifiersActionTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_MODIFIERS_BY_CUSTOMER = 'SET_MODIFIERS_BY_CUSTOMER',
	SET_MODIFIERS_BY_RESTAURANT = 'SET_MODIFIERS_BY_RESTAURANT',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	TOGGLE_REMEMBER_MY_CHOICE = 'TOGGLE_REMEMBER_MY_CHOICE',
	SET_FETCHED_CUSTOMERS = 'SET_FETCHED_CUSTOMERS',
	SET_ID_CUSTOMER = 'SET_ID_CUSTOMER',
	SET_ID_RESTAURANT = 'SET_ID_RESTAURANT',
	SET_ID_MODIFIER_GROUP = 'SET_ID_MODIFIER_GROUP',
	TOGGLE_IS_DISABLED = 'TOGGLE_IS_DISABLED',
	TOGGLE_IS_RESTRICTED = 'TOGGLE_IS_RESTRICTED',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	SET_SORT_BY = 'SET_SORT_BY',
	SET_COUNT_OF_ITEMS = 'SET_COUNT_OF_ITEMS',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	SET_ID_FOR_DELETION = 'SET_ID_FOR_DELETION',
	SET_ID_FOR_ASSIGN_RESTAURANTS = 'SET_ID_FOR_ASSIGN_RESTAURANTS',
	SET_ID_FOR_EDIT_MOD_GROUP_TEMPLATE = 'SET_ID_FOR_EDIT_MOD_GROUP_TEMPLATE',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	SET_FILTERS_FROM_QUERY_STRING = 'SET_FILTERS_FROM_QUERY_STRING',
}

interface IRefetchData {
	type: ModifiersActionTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IModifiersContext['needRefetchData'];
	};
}

interface ISetModifiersByCustomer {
	type: ModifiersActionTypes.SET_MODIFIERS_BY_CUSTOMER;
	payload: {
		modifiersByCustomer: IModifiersContext['modifiersByCustomer'];
		typeOfModalWindow: IModifiersContext['typeOfModalWindow'];
	};
}

interface ISetModifiersByRestaurant {
	type: ModifiersActionTypes.SET_MODIFIERS_BY_RESTAURANT;
	payload: {
		modifiersByRestaurant: IModifiersContext['modifiersByRestaurant'];
		typeOfModalWindow: IModifiersContext['typeOfModalWindow'];
	};
}

interface IChangeSearchString {
	type: ModifiersActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: IModifiersContext['searchString'];
	};
}

interface IToggleRememberMyChoice {
	type: ModifiersActionTypes.TOGGLE_REMEMBER_MY_CHOICE;
	payload: {
		rememberMyChoice: IModifiersContext['rememberMyChoice'];
	};
}

interface ISetFetchedCustomers {
	type: ModifiersActionTypes.SET_FETCHED_CUSTOMERS;
	payload: {
		fetchedCustomers: IModifiersContext['fetchedCustomers'];
	};
}

interface ISetIDCustomer {
	type: ModifiersActionTypes.SET_ID_CUSTOMER;
	payload: {
		IDSelectedCustomer: IModifiersContext['IDSelectedCustomer'];
		modifiersByCustomer: IModifiersContext['modifiersByCustomer'];
		modifiersByRestaurant: IModifiersContext['modifiersByRestaurant'];
	};
}

interface ISetIDRestaurant {
	type: ModifiersActionTypes.SET_ID_RESTAURANT;
	payload: {
		IDSelectedRestaurant: IModifiersContext['IDSelectedRestaurant'];
		isDisabled: IModifiersContext['isDisabled'];
		isRestricted: IModifiersContext['isRestricted'];
	};
}

interface ISetIDModifierGroup {
	type: ModifiersActionTypes.SET_ID_MODIFIER_GROUP;
	payload: {
		IDSelectedModifierGroup: IModifiersContext['IDSelectedModifierGroup'];
	};
}

interface IToggleIsDisabled {
	type: ModifiersActionTypes.TOGGLE_IS_DISABLED;
	payload: {
		isDisabled: IModifiersContext['isDisabled'];
	};
}

interface IToggleIsRestricted {
	type: ModifiersActionTypes.TOGGLE_IS_RESTRICTED;
}

interface IResetSelectedControls {
	type: ModifiersActionTypes.RESET_SELECTED_CONTROLS;
}

interface ISetSortBy {
	type: ModifiersActionTypes.SET_SORT_BY;
	payload: {
		sortBy: IModifiersContext['sortBy'];
	};
}

interface ISetCountOfItems {
	type: ModifiersActionTypes.SET_COUNT_OF_ITEMS;
	payload: {
		countOfItems: IModifiersContext['countOfItems'];
	};
}

interface IChangeCurrentPage {
	type: ModifiersActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: IModifiersContext['currentPage'];
	};
}

interface ISetIDForDeletion {
	type: ModifiersActionTypes.SET_ID_FOR_DELETION;
	payload: {
		IDForDeletion: IModifiersContext['IDForDeletion'];
		typeOfModalWindow: IModifiersContext['typeOfModalWindow'];
	};
}

interface ISetIDForAssignRestaurant {
	type: ModifiersActionTypes.SET_ID_FOR_ASSIGN_RESTAURANTS;
	payload: {
		IDForAssignRestaurants: IModifiersContext['IDForDeletion'];
		typeOfModalWindow: IModifiersContext['typeOfModalWindow'];
	};
}

interface ISetIDForEditModGroupTemplate {
	type: ModifiersActionTypes.SET_ID_FOR_EDIT_MOD_GROUP_TEMPLATE;
	payload: {
		IDForEditModGroupTemplate: IModifiersContext['IDForEditModGroupTemplate'];
		typeOfModalWindow: IModifiersContext['typeOfModalWindow'];
	};
}

interface IChangeTypeOfModalWindow {
	type: ModifiersActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IModifiersContext['typeOfModalWindow'];
	};
}

interface ISetFiltersFromQueryString {
	type: ModifiersActionTypes.SET_FILTERS_FROM_QUERY_STRING;
	payload: {
		filters: IFilterValues;
	};
}

export type TModifiersAction =
	| IRefetchData
	| ISetModifiersByCustomer
	| ISetModifiersByRestaurant
	| IChangeSearchString
	| IToggleRememberMyChoice
	| ISetFetchedCustomers
	| ISetIDCustomer
	| ISetIDRestaurant
	| ISetIDModifierGroup
	| IToggleIsDisabled
	| IToggleIsRestricted
	| IResetSelectedControls
	| ISetSortBy
	| ISetCountOfItems
	| IChangeCurrentPage
	| ISetIDForDeletion
	| ISetIDForAssignRestaurant
	| ISetIDForEditModGroupTemplate
	| IChangeTypeOfModalWindow
	| ISetFiltersFromQueryString;
